import addComma from "../../Functions/numberFormat";
import { quantityItem } from "../../helper/functions";
import { Authorization } from "../../providers/AuthContextProvider";
import { CartContext } from "../../providers/CartContextProvider";
import { Fragment, useContext, useEffect, useState } from "react";
import { BaseURL } from "../../config/axios";
import Address from "../../Components/shipping/Address";
import useAxios from "../../hooks/useAxios";
import Calculator, { CalculateAmound } from "../../helper/calculateDiscountValue";
import { useNavigate } from "react-router-dom";
import { BreadcrumbItem, Breadcrumbs, Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Select, SelectItem, useDisclosure } from "@nextui-org/react";
import { list } from "./list";

const Shipping = () => {
    const push = useNavigate()
    const { AxiosPrivate } = useAxios()
    const { state, dispatch } = useContext(CartContext)
    const { address } = state
    const { user } = useContext(Authorization)

    const [value, setValue] = useState("");
    const [discount, setDiscount] = useState()
    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)



    const { isOpen, onOpen, onOpenChange } = useDisclosure();

    useEffect(() => {
        if (!Object.keys(user).length) {
            alert('لطفا ابتدا وارد حساب کاربری خود شوید')
            push('/auth/login')
        } else if (user.is_admin) {
            alert('ادمین نمیتواند سفارش ثبت کند')
            push('/checkout/cart')
        } else if (!user.mobile_verified_at) {
            alert('لطفا ابتدا شماره موبایل خود را اعتبارسنجی کنید')
            push(`/${user.is_admin ? 'admin' : 'profile'}/information`)
        }
    }, [user])


    const handlePurchase = async () => {
        if (!Object.keys(address).length) alert('آدرس به درستی ثبت نشده است')
        else {
            setLoading(true)
            onOpenChange(true)
        }
    }

    const handlePay = async () => {

        await AxiosPrivate.post('order/final_purchase', { address: address, discount, type_of_know: value })
            .then(res => {
                window.location.replace(res.data.data.redirect_url)
                dispatch({ type: 'CLEAR' })
            })
            .catch(err => alert(err.response?.data.message || 'سفارش ثبت نشد'))
            .finally(() => {
                setLoading(false)
                onOpenChange(false)
            })
    }


    const handleSelectionChange = (e) => {
        setValue(e.target.value);
    };

    const handleDiscount = async ({ currentTarget }) => {
        const { value } = currentTarget.nextSibling
        if (!value.trim())
            alert('فرمت کد تخفیف صحیح نیست')
        else if (!Object.keys(address).length)
            alert('آدرس به درستی ثبت نشده است')
        else {
            setLoading2(true)
            await AxiosPrivate.get(`/discount/check?discount=${value}`)
                .then(res => {
                    alert(res.data.message)
                    setDiscount(res.data.data[0])
                }).catch(err => {
                    alert(err.response?.data.message || 'مشکلی رخ داده است')
                    setDiscount()
                })
                .finally(() => setLoading2(false))
        }
    }

    return (
        <>
            <title>حمل و نقل</title>
            <main className="min-h-[500px] py-4 cart_bgimg">
                <div className="container">
                    <Breadcrumbs separator='/' className="pr-6 mb-4" dir="rtl" itemClasses={{ separator: "px-2" }}>
                        <BreadcrumbItem href="/">صفحه اصلی</BreadcrumbItem>
                        <BreadcrumbItem>ثبت نهایی</BreadcrumbItem>
                    </Breadcrumbs>
                    <div className="flex flex-col gap-3">
                        <Address />
                        {state.itemsCounter
                            && <div className="grid lg:grid-cols-4 lg:gap-0 gap-3">
                                <div
                                    className="lg:col-span-3 col-span-4 lg:order-last flex flex-col rounded p-3 bg-white bg-opacity-70">
                                    {state.items.map((p, i) => {
                                        return (
                                            <Fragment key={p.uniqueId}>
                                                <div className="py-2">
                                                    <div className="grid grid-cols-6 items-center sm:gap-0 gap-4">
                                                        <div
                                                            className="sm:col-span-2 sm:order-4 col-span-6 centerOfParent mx-auto max-w-[300px] max-h-[200px] h-full overflow-hidden">
                                                            <img width={100} height={100}
                                                                src={(p.mainImage || BaseURL + p.images[0]?.path)}
                                                                className="w-full h-full" alt={p.title} />
                                                        </div>
                                                        <div
                                                            className="sm:col-span-3 sm:order-2 col-span-6  m-auto w-full centerOfParent grow">
                                                            <div className="text-center">
                                                                <h3 className="text-xl mb-2"><b>{p.title}</b></h3>
                                                                <div className="text-base">{p.artist?.title}</div>
                                                                <div className="my-2 bg-zinc-300 h-[1px]" />
                                                                <div className="centerOfParent"><span
                                                                    className="text-xs mr-2">(اندازه تابلو)</span><b>{p.size.width} cm
                                                                        x {p.size.height} cm</b></div>
                                                                {!!p.frame.width &&
                                                                    <div className="font-thin text-xs"><b>(اندازه تابلو
                                                                        همراه با
                                                                        قاب) {p.size.width + (p.frame.width * 2)} cm
                                                                        x {p.size.height + (p.frame.width * 2)} cm</b>
                                                                    </div>}
                                                                <div className="my-2 bg-zinc-300 h-[1px]" />
                                                                {/*<div className="text-xs leading-6" dir="auto">*/}
                                                                {/*    <b>متوسط:</b> Leinwand Leonardo (Satin)*/}
                                                                {/*</div>*/}
                                                                {!!p.frame.title &&
                                                                    <div className="text-xs leading-6" dir="auto"><b>قاب
                                                                        نقاشی:</b> {p.frame.title}</div>}
                                                                <div className="text-xs leading-6" dir="auto"><b>نوع
                                                                    آویز:</b> دندانه دار فلزی
                                                                </div>
                                                                {!!p.passpartout && <>
                                                                    <div className="my-2 bg-zinc-300 h-[1px]" />
                                                                    <div className="text-xs leading-6" dir="auto"><b>اندازه
                                                                        پاسپارتو:</b> {p.passpartout} سانتی متر
                                                                    </div>
                                                                </>}
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="sm:col-span-1 sm:order-1 col-span-6 my-auto h-full flex flex-col items-center justify-around">
                                                            <div
                                                                className='flex items-center border border-primary rounded text-primary px-3'>
                                                                <div
                                                                    className='centerOfParent text-xl my-1 mr-3'>{quantityItem(state, p)}</div>
                                                                : تعداد
                                                            </div>
                                                            <div className="flex flex-col items-center gap-2">
                                                                <span>:مجموع کل</span>
                                                                <p className="centerOfParent flex-row-reverse text-center text-[16px]">
                                                                    <span
                                                                        className="font-bold">{addComma(p.price.price)}</span>
                                                                    <span className="mr-2">تومان</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {(state.items.length - i !== 1) &&
                                                    <div className="my-3 bg-zinc-400 h-[1px]" />}
                                            </Fragment>
                                        )
                                    })}
                                </div>
                                <div className="lg:col-span-1 col-span-4 bg-[#343a40] rounded p-4 text-slate-200">
                                    <div className="lg:max-w-[304px] mx-auto">
                                        <div dir="rtl">
                                            <h3 className="text-lg mt-4">سفارش شما</h3>
                                            <div className="my-4 bg-zinc-500 h-[1px]" />
                                            <div className="flex flex-col gap-3">
                                                <div className="flex items-center justify-between">
                                                    <label>{state.itemsCounter} تابلو</label><span>{addComma(state.total)} تومان</span>
                                                </div>
                                                <div className="flex items-center justify-between text-sm">
                                                    <label>هزینه ارسال</label>
                                                    <span>{Object.keys(address).length ? (address.cost && `${addComma(Number(address.cost))} تومان`) : 'در انتظار ثبت آدرس'}</span>
                                                </div>
                                            </div>
                                            <div className="my-4 bg-zinc-500 h-[1px]" />
                                            <div className="flex flex-col gap-1">
                                                <div className="flex items-center justify-between">
                                                    <label>جمع</label><span>{addComma(!!discount ? Calculator(discount, state.total_price + address.cost) : state.total_price + (address.cost || 0))} تومان</span>
                                                </div>
                                            </div>
                                            {!!discount && <div className="mt-4 text-sm text-gray-400">
                                                <label>- {CalculateAmound(discount, state.total_price + address.cost)} تومان
                                                    بابت کد تخفیف از مبلغ کم شود</label>
                                            </div>}
                                            <div className="mt-8">
                                                <label className="block my-2 text-sm font-medium dark:text-white">کد
                                                    تخفیف</label>
                                                <div className="flex">
                                                    <button disabled={loading2} type="button" onClick={handleDiscount}
                                                        className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600">
                                                        {loading2 ? <svg className="animate-spinner-ease-spin" stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M12 6l0 -3"></path><path d="M6 12l-3 0"></path><path d="M7.75 7.75l-2.15 -2.15"></path></svg>
                                                            : "ثبت کد"}
                                                    </button>
                                                    <input type="text" id="website-admin"
                                                        className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" onClick={handlePurchase} disabled={loading}
                                            className="centerOfParent h-11 rounded-lg text-white w-full mt-4 bg-gradient-to-r from-[#C3003F] to-[#5D001E] hover:bg-gradient-to-br focus:outline-none font-medium rounded-lgpx-5 py-2.5 text-center me-2 mb-2">
                                            {loading ? <div className="dot-shuttle"></div> : 'ثبت سفارش'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <Modal
                        isDismissable={false}
                        hideCloseButton
                        dir="rtl"
                        isOpen={isOpen}
                        onOpenChange={onOpenChange}>
                        <ModalContent>
                            {(onClose) => (
                                <>
                                    <ModalHeader>روش اشنایی شما با ما چگونه بود؟</ModalHeader>
                                    <ModalBody>
                                        <div className="flex w-full flex-wrap md:flex-nowrap gap-4">
                                            <Select
                                                selectedKeys={[value]}
                                                onChange={handleSelectionChange}
                                                placeholder="انتخاب">
                                                {list.map((l) => (
                                                    <SelectItem key={l.key} className="flex-row-reverse" textValue={l.key}>
                                                        <p className="flex items-center justify-end w-full">{l.key}</p>
                                                    </SelectItem>
                                                ))}
                                            </Select>
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        {!!value.length && <Button variant="flat" onPress={handlePay} color="success">پرداخت</Button>}
                                    </ModalFooter>
                                </>
                            )}
                        </ModalContent>
                    </Modal>
                </div>
            </main>
        </>
    );
};

export default Shipping;